import React, { useEffect, useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { colors } from '@skyslope/mache';
import SignatureCanvas from 'react-canvas-draw';
import { IS_MOBILE } from '../../common/constants';

type Dimension = {
  width: number;
  height: number;
};

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const getDimensions = (rect: Dimension) => ({ height: rect.height, width: rect.width });

export const CanvasWrapper = React.forwardRef(
  (
    props: {
      onEnd: () => void;
      canvasProps: any;
      hasContent: boolean;
      ['data-spec']: string;
      canvasWidth: number;
      setMaxWidth: (width: number) => void;
    },
    ref
  ) => {
    const [canvasSizeData, setData] = useState({ newDimensions: undefined });
    const [canvasWidth, setCanvasWidth] = useState(0);
    const landscapeMediaQuery = useMediaQuery('(orientation: landscape)');
    const showExtendedCanvas = canvasWidth && props.hasContent && !landscapeMediaQuery && IS_MOBILE;
    useEffect(() => {
      // @ts-expect-error -- This code was written prior to enforcing lint rules
      if (ref.current.canvas.drawing.clientWidth > canvasWidth) {
        // @ts-expect-error -- This code was written prior to enforcing lint rules
        setCanvasWidth(ref.current.canvas.drawing.clientWidth);
        // @ts-expect-error -- This code was written prior to enforcing lint rules
        props.setMaxWidth(ref.current.canvas.drawing.clientWidth);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [landscapeMediaQuery]);

    useEffect(() => {
      if (!props.hasContent) {
        // @ts-expect-error -- This code was written prior to enforcing lint rules
        setCanvasWidth(null);
      }
    }, [props.hasContent]);
    // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
    const onChange = () => {
      // @ts-expect-error -- This code was written prior to enforcing lint rules
      if (ref?.current?.canvas?.temp) {
        // @ts-expect-error -- This code was written prior to enforcing lint rules
        const drawingData = JSON.parse(ref.current.getSaveData());
        // @ts-expect-error -- This code was written prior to enforcing lint rules
        if (canvasSizeData.drawingData) {
          // @ts-expect-error -- This code was written prior to enforcing lint rules
          if (drawingData.lines.length !== 0 && canvasSizeData.drawingData.lines.length > drawingData.lines.length) {
            // @ts-expect-error -- This code was written prior to enforcing lint rules
            const _data = {
              // @ts-expect-error -- This code was written prior to enforcing lint rules
              newDimensions: getDimensions(ref.current.canvas.temp),
              oldDimensions: canvasSizeData.newDimensions,
              drawingData,
            };
          } else {
            const data = {
              // @ts-expect-error -- This code was written prior to enforcing lint rules
              newDimensions: getDimensions(ref.current.canvas.temp),
              oldDimensions: canvasSizeData.newDimensions,
              drawingData,
            };
            // @ts-expect-error -- This code was written prior to enforcing lint rules
            setData(data);
          }
        } else {
          const data = {
            // @ts-expect-error -- This code was written prior to enforcing lint rules
            newDimensions: getDimensions(ref.current.canvas.temp),
            oldDimensions: canvasSizeData.newDimensions,
            drawingData,
          };
          // @ts-expect-error -- This code was written prior to enforcing lint rules
          setData(data);
        }
      }
      props.onEnd();
    };
    console.info('Rendering, ', props['data-spec'], 'with width of, ', props.canvasWidth);
    return (
      <SignatureCanvas
        hideInterface={true}
        // @ts-expect-error -- This code was written prior to enforcing lint rules
        ref={ref}
        style={{
          width: showExtendedCanvas ? props.canvasWidth : '100%',
          height: '172px',
          position: 'relative',
          border: showExtendedCanvas ? `1px solid ${colors.grey[800]}` : '',
        }}
        onChange={onChange}
        brushRadius={2}
        brushColor={'#000'}
        hideGrid
        lazyRadius={0}
        data-spec={`${props['data-spec']}-draw`}
      />
    );
  }
);
